import React from 'react';
import { Compass, Heart, Award, Sparkles, Building } from 'lucide-react';
import './AboutUs.css';

export default function AboutUs() {
  const team = [
    {
      name: 'Vikram Aditya',
      role: 'Founder & Managing Director',
      bio: 'Ex-consultant & travel enthusiast with 15+ years experience building customized international tour systems.',
      avatar: 'VA'
    },
    {
      name: 'Priyanka Sen',
      role: 'Head of Domestic Curations',
      bio: 'Specializes in offbeat Indian retreats, heritage tours, and luxury cultural circuits in Rajasthan & Kerala.',
      avatar: 'PS'
    },
    {
      name: 'David Miller',
      role: 'Lead Destination Specialist',
      bio: 'Expert in European alpine routes and tropical beach escapes. Crafted over 500+ customized tours.',
      avatar: 'DM'
    }
  ];

  const values = [
    {
      icon: <Award size={24} />,
      title: 'Obsessive Quality',
      desc: 'We personally inspect accommodations, local transport links, and check guide certifications regularly.'
    },
    {
      icon: <Heart size={24} />,
      title: 'Customer First',
      desc: 'From custom adjustments on itineraries to direct 24/7 concierge assistance during active tours.'
    },
    {
      icon: <Compass size={24} />,
      title: 'Responsible Travel',
      desc: 'Supporting local communities, promoting eco-tours, and reducing environment footprint is core to our mission.'
    }
  ];

  return (
    <div className="about-page">
      {/* Narrative Section */}
      <section className="about-hero container section">
        <div className="about-hero-grid">
          <div className="about-hero-text">
            <span className="badge badge-gold">
              <Sparkles size={12} style={{ marginRight: '4px' }} />
              Our Journey
            </span>
            <h2>Who is Holiday Kart?</h2>
            <p className="hero-lead">
              Founded in 2018, Holiday Kart was born out of a simple idea: making custom travel luxury accessible to everyone. We believe travel should be deeply personal, seamless, and filled with magic.
            </p>
            <p>
              We are not just a travel agency. We are vacation architects. We spend hours researching local highlights, vetting boutique accommodations, and designing day plans that help you truly immerse in a destination rather than just ticking boxes on a checklist.
            </p>
          </div>
          <div className="about-hero-graphic glass-card floating">
            <Compass size={80} className="large-compass-icon" />
            <div className="graphic-stats">
              <span>Established <strong>2018</strong></span>
              <span>Offices <strong>Noida & Bangalore</strong></span>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="about-values section bg-alt">
        <div className="container">
          <div className="section-title">
            <h2>Our Core Principles</h2>
            <p>The guidelines that drive our curators to deliver stellar hospitality day in and day out.</p>
          </div>

          <div className="grid grid-3 values-grid">
            {values.map((val, idx) => (
              <div key={idx} className="value-card glass-card">
                <div className="value-icon-wrapper">
                  {val.icon}
                </div>
                <h3>{val.title}</h3>
                <p>{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team container section">
        <div className="section-title">
          <h2>Meet the Holiday Architects</h2>
          <p>Our experienced team of curators, guides, and customer care specialists.</p>
        </div>

        <div className="grid grid-3 team-grid">
          {team.map((member, idx) => (
            <div key={idx} className="team-card glass-card">
              <div className="team-avatar-wrapper">
                <div className="team-avatar">{member.avatar}</div>
              </div>
              <h3 className="team-name">{member.name}</h3>
              <span className="team-role">{member.role}</span>
              <p className="team-bio">{member.bio}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Partner Trust Grid */}
      <section className="about-partners section bg-alt">
        <div className="container">
          <div className="section-title">
            <h2>Recognized & Trusted By</h2>
            <p>We work with industry leading global associations to ensure safety and security.</p>
          </div>

          <div className="grid grid-4 partner-grid">
            <div className="partner-card glass-card">
              <Building className="partner-icon" />
              <span>IATA Approved</span>
            </div>
            <div className="partner-card glass-card">
              <Building className="partner-icon" />
              <span>Ministry of Tourism</span>
            </div>
            <div className="partner-card glass-card">
              <Building className="partner-icon" />
              <span>TAAI Member</span>
            </div>
            <div className="partner-card glass-card">
              <Building className="partner-icon" />
              <span>Safe Travel Standard</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
